<script>
  /* Executable code section of the program */
  //Tools importation
  import {temporalAttendee,isOnetoOneMeetingsOn,isChatModalOn,temporalChatAttendee,userRealTime} from "../../apis/storage"

  //Auxiliary Variables
  export let attendee;
  let avatarColor = "#ed2824"

     //Function display meetings modal
     const displayMeetModal = (data) => {
    let windowWidth = window.innerWidth;
    $temporalAttendee = data;
    $isOnetoOneMeetingsOn = true; 
  };
  
  //Function to display chat modal
  const displayChatModal = (attendee) =>{
    $isChatModalOn =  true
    $temporalChatAttendee = attendee
    
  }
  /* End of the section */
</script>

<!-- Section to place the HTML code -->

<body class="cardContainer">
    <div class="card">
      <div class="profileImgContainer">
        {#if attendee.profileImgUrl === "" || attendee.profileImgUrl === undefined}
          <div class="circle" style="--avatar-color:{avatarColor}">
            <h3>{attendee.name.slice(0, 1)}{attendee.surname.slice(0, 1)}</h3>
          </div>
        {:else}
          <img src={attendee.profileImgUrl} alt="avatar" />
        {/if}
      </div>
      <div class="infoContainer">
        <h4>{attendee.name} {attendee.surname}</h4>
        <p>{attendee.jobtittle} <br>
          {attendee.company} <br>
          {attendee.country} <br>
        </p>
      </div>
      <div class="actionsBtnContainer">
        <button class="actionBtn addEventBtn" on:click={()=>displayChatModal(attendee)}>Chat</button>
        {#if $userRealTime.availableMeet || $userRealTime.userRole !=="attendee"}
        <button class="actionBtn addEventBtn" on:click={()=>displayMeetModal(attendee)}>Meeting</button>
        {/if}
      </div>
    </div>
</body>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .cardContainer {
    width: 25%;
    height: auto;
    display: flex;
    margin: 5px 0;
    background-color: #f4f4f4;
  }
  .card {
    width: 100%;
    height: auto;
    margin: 0 5px;
    padding: 10px 0;
    background-color: white;
  }
  .profileImgContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
  }
  img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .circle {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: var(--avatar-color);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }
  .infoContainer {
    display: flex;
    text-align: center;
    flex-direction: column;
    padding: 10px 0;
  }
  .actionsBtnContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .actionBtn {
    width: 90%;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 5px 20px;
  }

  .addEventBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .cardContainer {
    width: 30%;
    height: auto;
    margin: 0 5px;
    padding: 10px 0;
  }
  .card {
    width: 100%;
    height: auto;
    margin: 0 5px;
    padding: 10px;
    background-color: white;
  }
    .infoContainer {
    display: flex;
    text-align: center;
    flex-direction: column;
    padding: 10px;
  }
    p{
        line-height: .9;
        text-align: center;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .cardContainer {
    width: 100%;
    height: auto;
    margin: 0 5px;
    padding: 10px 0;
  }
  }

  /* End of the section */
</style>
